import React from 'react';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { getFiltersCount } from '../../../utils';
import { FiltersCountContainer } from './styled';

type FilterCountProps = {
  withNumber: boolean;
  isAllFilters: boolean;
  showOnRight?: boolean;
};

const FiltersCount = ({ withNumber, isAllFilters, showOnRight }: FilterCountProps) => {
  const { isMobile, isTablet } = useCommonClient();
  const filtersCount = getFiltersCount();
  const show = isAllFilters ? filtersCount > 0 : true;

  return (
    show && (
      <FiltersCountContainer
        showOnRight={showOnRight}
        withNumber={withNumber}
        isMobile={isMobile}
        isTablet={isTablet}
        className={`counter ${withNumber ? 'counter-with-number' : 'counter-no-number'}`}
      >
        {withNumber && filtersCount}
      </FiltersCountContainer>
    )
  );
};

export default FiltersCount;
